/** @jsxImportSource @emotion/react */
import { VideoIcon } from '@kaiizen/kai-shiki/react';

import { AIScanVideoUploadTriggerButton } from '../AIScanVideoUploadModal/AIScanVideoUploadTriggerButton';
import {
  ORIGINATION_EMPTY_DESC_STYLE,
  ORIGINATION_EMPTY_ICON_STYLE,
  ORIGINATION_EMPTY_STATE_STYLE,
  ORIGINATION_EMPTY_TITLE_STYLE,
  ORIGINATION_VIDEO_REQS_HEADING_STYLE,
  ORIGINATION_VIDEO_REQS_LIST_STYLE,
  ORIGINATION_VIDEO_REQS_STYLE,
} from './scopeVideoOriginationEmptyStateStyles';

const VIDEO_REQUIREMENTS = [
  'One video per upload',
  '30 mins and 8 gig max each',
  'MP4, MOV or WEBM file types accepted',
] as const;

export type ScopeVideoOriginationEmptyStateProps = {
  activeCount?: number;
  onUploadVideos?: () => void;
};

/** Step 1 · Empty draft — scope-level origination empty state for the Focus Panel Editor. */
export const ScopeVideoOriginationEmptyState = ({
  activeCount = 0,
  onUploadVideos,
}: ScopeVideoOriginationEmptyStateProps) => (
  <div css={ORIGINATION_EMPTY_STATE_STYLE} data-testid={'scope-video-origination-empty-state'}>
    <div css={ORIGINATION_EMPTY_ICON_STYLE}>
      <VideoIcon size={28} color={'currentColor'} aria-hidden={'true'} />
    </div>
    <h2 css={ORIGINATION_EMPTY_TITLE_STYLE}>Jumpstart your scope with video</h2>
    <p css={ORIGINATION_EMPTY_DESC_STYLE}>
      Upload videos of the property. Kai pulls images from your footage and drafts the tasks, so you review and edit instead of starting from scratch.
    </p>
    <AIScanVideoUploadTriggerButton
      variant={'emptyStateCta'}
      activeCount={activeCount}
      disabled={!onUploadVideos}
      onClick={() => onUploadVideos?.()}
    />
    <div css={ORIGINATION_VIDEO_REQS_STYLE}>
      <div css={ORIGINATION_VIDEO_REQS_HEADING_STYLE}>
        <span>Video requirements</span>
      </div>
      <ul css={ORIGINATION_VIDEO_REQS_LIST_STYLE}>
        {VIDEO_REQUIREMENTS.map(requirement => <li key={requirement}>{requirement}</li>)}
      </ul>
    </div>
  </div>
);
